module.exports = __webpack_public_path__ + "img/vb-logo.4d86a60e.svg";